"use client";

import { useEffect } from "react";
import Script from "next/script";
import { AppConfig } from "~/utils/AppConfig";
import { useUnauthorizedEventService } from "~/services/api/services/event";
import { sendAbTestEvent } from "~/lib/optimizely/sendAbTestEvent";

export default function OptimizelyScript() {
    const sendBigQueryEvent = useUnauthorizedEventService();

    useEffect(() => {
        const customEvent = new CustomEvent("optimizely/campaign/decided");

        if (!AppConfig.isProduction) {
            dispatchEvent(customEvent);
            return;
        }

        function onCampaignDecided(event: { data: { decision: { experimentId: string; variationId: string } } }) {
            sendAbTestEvent(sendBigQueryEvent, event.data.decision.experimentId, event.data.decision.variationId);

            setTimeout(() => {
                dispatchEvent(customEvent);
            }, 100);
        }

        window["optimizely"] = window["optimizely"] || [];

        window.optimizely.push({
            type: "addListener",
            filter: {
                type: "lifecycle",
                name: "campaignDecided"
            },
            handler: onCampaignDecided
        });

        window.optimizely.push({
            type: "addListener",
            filter: {
                type: "lifecycle",
                name: "sdkInitialized"
            },
            handler: function() {
                const variations = window.optimizely.get("state").getVariationMap() || {};
                if (Object.keys(variations).length === 0) dispatchEvent(customEvent);
            }
        });
    }, [sendBigQueryEvent]);

    if (!AppConfig.isProduction) {
        return null;
    }

    return <Script src="https://cdn.optimizely.com/js/4692478322802688.js" crossOrigin="anonymous" />
}
